import React, { useRef, useState } from "react";
import { FaPlus, FaMinus } from "react-icons/fa6";

const Faqs = () => {
  const [openIndex, setOpenIndex] = useState(null);
  const contentRefs = useRef([]);
  const faqData = [
    {
      question: "Za koga je priporočena ta črpalka?",
      answer: (
        <>
          Sistem MiniMed™ 780G je odobren za osebe s sladkorno boleznijo tipa 1, stare 7 let in več. 
        </>
      ),
    },
    {
      question: "Ali sistem komunicira z mojim pametnim telefonom?",
      answer: (
        <>
          Da. S sistemom MiniMed™ 780G lahko preprosto spremljate raven glukoze in prejemate obvestila ter opozorila na pametnem telefonu. Povabite lahko do 5 oseb, ki si lahko prenesejo aplikacijo CareLink™ Connect in v realnem času spremljajo vaše vrednosti glukoze na svojih telefonih. Aplikacija je na voljo za prenos brezplačno za večino pametnih telefonov z operacijskim sistemom iOS in Android. Če želite preveriti združljivost vašega telefona, obiščite stran z{" "}
          <a
            href="https://www.medtronic-diabetes.com/en-gb/check-compatibility-app"
            className="text-blue-600 hover:underline"
          >
            referenčno tabelo
          </a>
          .
        </>
      ),
    },
    {
      question: "Kaj je tako edinstvenega pri sistemu MiniMed™ 780G?",
      answer: (
        <>
          Sistem MiniMed™ 780G samodejno prilagaja dovajanje inzulina vašim potrebam, za lažjo stabilizacijo ravni glukoze¹,²,³. Sistem vključuje napredno raven avtomatizacije za vodenje sladkorne bolezni, imenovano tehnologija SmartGuard™. Če vaše vrednosti glukoze naraščajo, vam sistem dovaja več inzulina. Če vrednosti padajo, vam dovaja manj ali nič inzulina. Sistem lahko celo popravlja visoke vrednosti glukoze (dovaja korekcijske odmerke) v primeru, ko vaša ocena zaužitih ogljikovih hidratov ni povsem natančna.
        </>
      ),
    },
    {
      question: "Kako se ta sistem razlikuje od uporabe samo črpalke?",
      answer: `Sistem MiniMed™ 780G samodejno prilagaja dovajanje bazalnega inzulina na podlagi vrednosti neprekinjenega merjenja glukoze (CGM). To pomeni, da črpalka samodejno prejme odčitke glukoze s senzorja in nato 24 ur na dan dovaja prilagodljivo količino inzulina glede na vaše potrebe. Ta integrirani sistem – torej kombinacija črpalke in neprekinjenega merjenja, ki med seboj komunicirata – pomaga stabilizirati vaše ravni glukoze in preprečevati visoke ter nizke vrednosti.`,
    },
    {
      question:
        "Ali moram še vedno meriti glukozo v krvi z merilnikom ali si injicirati inzulin s peresnikom?",
      answer: (
        <>
          Pri uporabi inzulinske črpalke se število injiciranj močno zmanjša – do 90 %*. Infuzijski set vsebuje majhno, upogljivo plastično kanilo, ki se vstavi pod kožo in jo zamenjate vsakih 7 dni. Senzor za merjenje glukoze se prav tako vstavi vsakih 7 dni. Uporaba funkcije SmartGuard™ ne nadomesti povsem meritev s prsta, vendar boste manj pogosto preverjali raven glukoze v krvi. Odčitki senzorja so pridobljeni iz medcelične tekočine (tekočina okoli celic v tkivu) in ne iz krvi, zato morate še vedno občasno izmeriti raven glukoze z merilnikom. Z uporabo senzorja in oddajnika Guardian™ 4/senzorja Simplera Sync™ je meritev glukoze v krvi potrebna le ob prvem vklopu funkcije SmartGuard™, sicer meritve iz krvi niso potrebne. Če opozorila in odčitki senzorja niso skladni z vašimi simptomi, za sprejemanje odločitev glede zdravljenja uporabite meritev glukoze v krvi. Pomembno je vedeti, da se vse meritve glukoze v krvi, ki so vnesene v črpalko, uporabijo za umerjanje sistema. Glejte uporabniški priročnik sistema – funkcija SmartGuard™. Potrebni so nekateri ukrepi uporabnika.
          <br />
          <br />
          *O predpostavki štirih injekcij na dan, 30 dni in ena menjava infuzijskega seta vsaka dva do tri dni.
        </>
      ),
    },
    {
      question: "Ali je ta črpalka vodoodporna?",
      answer: `*Ob izdelavi in pri pravilno nameščenem rezervoarju ter infuzijskem setu je vaš sistem vodotesen. Čeprav je sistem vodotesen, lahko padci in udarci skozi čas povzročijo večjo občutljivost ohišja na vdor vode: priporočamo, da črpalko pred plavanjem ali kopanjem odstranite. Odčitki senzorja se v času, ko ste v vodi morda ne bodo prenašali v črpalko.`,
    },
    {
      question:
        "Kaj so naslednji koraki, če me zanima začetek uporabe?",
      answer: (
        <>
          Na naslovu <a className="text-blue-600 hover:underline" href="mailto:podpora@zaloker-zaloker.si">podpora@zaloker-zaloker.si</a> nam pustite svoje kontaktne podatke in poklical vas bo tehnični edukator. Pomagali vam bomo odgovoriti na vprašanja in z vami uskladiti termin tehnične edukacije, če sta se z vašim zdravnikom že odločila za prehod na ta način zdravljenja sladkorne bolezni. V nadaljevanju vas bo edukator usposobil za uporabo sistema MiniMed 780G in vas spremljal ter vam bil na voljo ves čas uporabe sistema. 
        </>
      ),
    },
    
  ];

  const toggleAccordion = (index) => {
    setOpenIndex(index === openIndex ? null : index);
  };

  return (
    <section className="py-8 px-5 lg:px-28">
      <h2 className="my-5 text-2xl md:text-4xl font-light md:leading-[4.5rem]">
        Pogosto zastavljena vprašanja
      </h2>
      {faqData.map((faq, index) => (
        <div
          key={index}
          className="py-2 lg:py-7 border-b border-gray-200 group"
        >
          <div className="py-1 lg:py-2">
            <button
              className="w-full flex justify-between items-center text-left focus:outline-none"
              onClick={() => toggleAccordion(index)}
            >
              <span className="p-0.5 lg:p-1.5 ml-3 text-lg md:text-2xl lg:text-2xl font-light text-black">
                {faq.question}
              </span>
              <div className="pr-5 mt-0.5 ml-2 text-gray-800 text-lg group-hover:text-gray-800">
                {openIndex === index ? (
                  <div className="bg-red-500 rounded-full h-8 w-8 flex items-center justify-center">
                    <FaMinus className="text-white" />
                  </div>
                ) : (
                  <div className="bg-red-500 rounded-full h-8 w-8 flex items-center justify-center">
                    <FaPlus className="text-white" />
                  </div>
                )}
              </div>
            </button>
          </div>
          <div
            className={`transition-all duration-700 ease-in-out overflow-hidden`}
            style={{
              maxHeight:
                openIndex === index
                  ? `${contentRefs.current[index]?.scrollHeight}px`
                  : "0px",
            }}
            ref={(el) => (contentRefs.current[index] = el)}
          >
            <div className="text-lg font-normal py-7 mx-4 text-gray-700">
              {faq.answer}
            </div>
          </div>
        </div>
      ))}
    </section>
  );
};

export default Faqs;
